import { render, staticRenderFns } from "./BnplB2bApplication.vue?vue&type=template&id=4e4c036a&scoped=true&"
import script from "./BnplB2bApplication.vue?vue&type=script&lang=js&"
export * from "./BnplB2bApplication.vue?vue&type=script&lang=js&"
import style0 from "./BnplB2bApplication.vue?vue&type=style&index=0&id=4e4c036a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c036a",
  null
  
)

export default component.exports